import { memo } from 'react';
import { Box } from '@mui/material';
import Separator from 'components/common/Separator.js';

const SectionLayout = ({
  leftSide,
  rightSide,
  noSeparator = false,
  noBottomPadding,
  topPadding,
  children,
}) => {
  const paddingTop = topPadding ? topPadding : '32';

  return (
    <>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: leftSide ? '200px 636px' : '836px',
          gap: 6,
          margin: '0 auto',
          gridTemplateRows: 'auto',
          gridTemplateAreas: leftSide ? `"leftSide rightSide"` : `"rightSide"`,
          padding: !noBottomPadding ? paddingTop + 'px 0 32px 0' : paddingTop + 'px 0 0 0',
        }}
      >
        {leftSide && <Box sx={{ gridArea: 'leftSide' }}>{leftSide}</Box>}
        <Box sx={{ gridArea: 'rightSide' }}>{rightSide || children}</Box>
      </Box>
      {noSeparator ? null : <Separator />}
    </>
  );
};

export default memo(SectionLayout);
